function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './array.scss';
import CustomHTMLElement from 'html-element';

var InputArray = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(InputArray, _CustomHTMLElement);

  var _super = _createSuper(InputArray);

  function InputArray() {
    _classCallCheck(this, InputArray);

    return _super.apply(this, arguments);
  }

  _createClass(InputArray, [{
    key: "_runSetup",
    value: function _runSetup() {
      var _this = this;

      _get(_getPrototypeOf(InputArray.prototype), "_runSetup", this).call(this);

      this.name = this.getAttribute('name');
      this.itemContentTemplate = this.querySelector('[data-input-array-template]');
      this.addButton = this.querySelector('[data-input-array-add]');

      if (this.addButton) {
        this.addButton.addEventListener('click', function (_event) {
          return _this.addButtonClicked();
        });
      }

      this.addEventListener('dragover', this.draggedOver.bind(this));
    } ////////// Inputs

  }, {
    key: "inputs",
    get: function get() {
      return this.querySelectorAll('input-array-input');
    } ////////// Events
    // Add

  }, {
    key: "addButtonClicked",
    value: function addButtonClicked() {
      var input = new InputArrayInput(this.itemContentTemplate);
      this.insertBefore(input, this.addButton);
    } // Reorder

  }, {
    key: "beginDrag",
    value: function beginDrag(input) {
      this.draggingInput = input;
      this.calculateDrag();
    }
  }, {
    key: "calculateDrag",
    value: function calculateDrag() {
      this.dragInputs = Array.from(this.inputs);
      this.dragIndex = this.dragInputs.indexOf(this.draggingInput);
      var offset = document.documentElement.scrollTop - document.documentElement.clientTop;
      this.dragCenters = this.dragInputs.map(function (i) {
        var rect = i.getBoundingClientRect();
        return rect.top + rect.height / 2 + offset;
      });
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      this.draggingInput = null;
      this.dragInputs = null;
      this.dragCenters = null;
      this.dragIndex = null;
    }
  }, {
    key: "draggedOver",
    value: function draggedOver(event) {
      if (!this.draggingInput) {
        return;
      }

      event.preventDefault();
      var i = -1;

      do {
        i += 1;
      } while (i < this.dragInputs.length && event.pageY > this.dragCenters[i]);

      var insertIndex = i;

      if (i > this.dragIndex) {
        i -= 1;
      }

      if (this.dragIndex != i) {
        this.dragIndex = i;
        this.insertBefore(this.draggingInput, this.children[insertIndex]);
      }
    }
  }]);

  return InputArray;
}(CustomHTMLElement);

export { InputArray as default };
export var InputArrayInput = /*#__PURE__*/function (_CustomHTMLElement2) {
  _inherits(InputArrayInput, _CustomHTMLElement2);

  var _super2 = _createSuper(InputArrayInput);

  function InputArrayInput() {
    _classCallCheck(this, InputArrayInput);

    return _super2.apply(this, arguments);
  }

  _createClass(InputArrayInput, [{
    key: "_runSetup",
    value: function _runSetup(template) {
      var _this2 = this;

      _get(_getPrototypeOf(InputArrayInput.prototype), "_runSetup", this).call(this);

      if (template) {
        this.className = template.className;
        this.innerHTML = template.innerHTML;
      }

      this.dragButton = this.querySelector('[data-input-array-drag]');
      this.draggable = true;
      this.addEventListener('dragstart', this.dragStarted.bind(this));
      this.addEventListener('dragend', this.dragEnded.bind(this));
      this.removeButton = this.querySelector('[data-input-array-remove]');
      this.removeButton.addEventListener('click', function (_event) {
        return _this2.removeButtonClicked();
      });
    } ////////// Array

  }, {
    key: "inputArray",
    get: function get() {
      return this.parentElement;
    } ////////// Events
    // Reorder

  }, {
    key: "dragStarted",
    value: function dragStarted(event) {
      var _this3 = this;

      var eventElement = document.elementFromPoint(event.clientX, event.clientY);

      if (!eventElement || !eventElement.closest('[data-input-array-drag]')) {
        return event.preventDefault();
      }

      this.inputArray.beginDrag(this);
      setTimeout(function () {
        return _this3.style.opacity = 0;
      });
    }
  }, {
    key: "dragEnded",
    value: function dragEnded(_event) {
      this.inputArray.endDrag();
      this.style.opacity = '';
    } // Remove

  }, {
    key: "removeButtonClicked",
    value: function removeButtonClicked() {
      this.remove();
    }
  }]);

  return InputArrayInput;
}(CustomHTMLElement);
window.customElements.define('input-array', InputArray);
window.customElements.define('input-array-input', InputArrayInput);